import React, { Suspense, lazy } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { history } from "./history";
import { connect } from "react-redux";
import DefaultLayout from "./layout/DefaultLayout";
import Spinner from "./components/Spinner";

// 错误显示页面
const error404 = lazy(() => import("./pages/error/404"));
const error500 = lazy(() => import("./pages/error/500"));

// index
const IndexPage = lazy(() => import("./pages/index"));
// login
const loginPage = lazy(() => import("./pages/login"));
// register
const RegFirstPage = lazy(() => import("./pages/register/reg_first"));
const regStep2Page = lazy(() => import("./pages/register/reg_step2"));
const regStep3Page = lazy(() => import("./pages/register/reg_step3"));
const regStep4Page = lazy(() => import("./pages/register/reg_step4"));
const regStep5Page = lazy(() => import("./pages/register/reg_step5"));
// collect use information
const introPage = lazy(() => import("./pages/collect/intro"));
const collectStep1Page = lazy(() => import("./pages/collect/collect_step1"));
const collectStep2Page = lazy(() => import("./pages/collect/collect_step2"));
const collectStep3Page = lazy(() => import("./pages/collect/collect_step3"));
const collectStep4Page = lazy(() => import("./pages/collect/collect_step4"));
const collectStep5Page = lazy(() => import("./pages/collect/collect_step5"));
const collectStep6Page = lazy(() => import("./pages/collect/collect_step6"));

// user
// upload photo
const uploadPhotopage  = lazy(() => import("./pages/user/photo_upload"));

// staitc page
const userTermsPage   = lazy(() => import("./pages/staticpage/userterms"));
const dcmaPage   = lazy(() => import("./pages/staticpage/dcma"));
const yourPrivacyPage   = lazy(() => import("./pages/staticpage/privacypolicy"));
const aboutUsPage   = lazy(() => import("./pages/staticpage/aboutus"));
const cookiePolicyPage   = lazy(() => import("./pages/staticpage/CookiePolicy"));
const openStorePage = lazy(() => import("./pages/staticpage/openStore"));


const detailPage   = lazy(() => import("./pages/detail"));
const loverPage   = lazy(() => import("./pages/loverDetail"));

const editPage   = lazy(() => import("./pages/edit"));
const searchPage   = lazy(() => import("./pages/search"));
const friendListPage   = lazy(() => import("./pages/chat/friend_list"));
const chatInfoPage   = lazy(() => import("./pages/chat/chat_info"));
const buyVipPage  = lazy(() => import("./pages/vip"));
const rechargePage = lazy(() => import("./pages/recharge"));
const rechargeListPage = lazy(() => import("./pages/rechargeList"));

const interestedPage = lazy(() => import("./pages/interested"));

const successPage = lazy(() => import("./pages/payment/success"));
const failPage = lazy(() => import("./pages/payment/fail"));
const checkout = lazy(() => import("./pages/payment/checkout"));
const resultPage = lazy(() => import("./pages/payment/result"));

const mallHome = lazy(() => import("./pages/mall/home"));
const productDetail = lazy(() => import("./pages/mall/productDetail"));
const orders = lazy(() => import("./pages/mall/orders"));
const orderDetail = lazy(() => import("./pages/mall/orderDetail"));
const mallChcekout = lazy(() => import("./pages/mall/mallchcekout"));


//使用布局方式跳转路由
const RouteConfig = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <DefaultLayout>
          <Suspense fallback={<Spinner />}>
            <Component {...props} />
          </Suspense>
        </DefaultLayout>
      );
    }}
  />
);

const mapStateToProps = (state) => ({});
const AppRoute = connect(mapStateToProps)(RouteConfig);

//在这里注册所有的路由
export default class AppRouter extends React.Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <AppRoute exact path="/" component={IndexPage} />
          <AppRoute exact path="/index" component={IndexPage} />
          <AppRoute exact path="/login" component={loginPage} />
          <AppRoute exact path="/reg_first" component={RegFirstPage} />
          <AppRoute exact path="/regStep2" component={regStep2Page} />
          <AppRoute exact path="/regStep3" component={regStep3Page} />
          <AppRoute exact path="/regStep4" component={regStep4Page} />
          <AppRoute exact path="/regStep5" component={regStep5Page} />

          <AppRoute exact path="/intro" component={introPage} />
          <AppRoute exact path="/collectStep1" component={collectStep1Page} />
          <AppRoute exact path="/collectStep2" component={collectStep2Page} />
          <AppRoute exact path="/collectStep3" component={collectStep3Page} />
          <AppRoute exact path="/collectStep4" component={collectStep4Page} />
          <AppRoute exact path="/collectStep5" component={collectStep5Page} />
          <AppRoute exact path="/collectStep6" component={collectStep6Page} />
          
          <AppRoute exact path="/upload_photo" component={uploadPhotopage} />

          <AppRoute exact path="/detail" component={detailPage} />
          <AppRoute exact path="/lover" component={loverPage} />
          <AppRoute exact path="/edit" component={editPage} />
          <AppRoute exact path="/search" component={searchPage} />
          <AppRoute exact path="/likes" component={friendListPage} />
          <AppRoute exact path="/chat" component={chatInfoPage} />
         
          <AppRoute exact path="/userterms" component={userTermsPage} />
          <AppRoute exact path="/dcma" component={dcmaPage} />
          <AppRoute exact path="/yourprivacy" component={yourPrivacyPage} />
          <AppRoute exact path="/aboutus" component={aboutUsPage} />
          <AppRoute exact path="/cookiePolicy" component={cookiePolicyPage} />
          <AppRoute exact path="/openStore" component={openStorePage} />
          

          <AppRoute exact path="/vip" component={buyVipPage} />
          <AppRoute exact path="/recharge" component={rechargePage} />
          <AppRoute exact path="/rechargeList" component={rechargeListPage} />

          <AppRoute exact path="/interested" component={interestedPage} />

          <AppRoute exact path="/payment/success" component={successPage} />
          <AppRoute exact path="/payment/fail" component={failPage} />
          <AppRoute exact path="/payment/checkout" component={checkout} />
          <AppRoute exact path="/payment/result" component={resultPage} />

          <AppRoute exact path="/mall" component={mallHome} />
          <AppRoute exact path="/mall/product" component={productDetail} />
          <AppRoute exact path="/mall/orders" component={orders} />
          <AppRoute exact path="/mall/orderDetail" component={orderDetail} />
          <AppRoute exact path="/mall/checkout" component={mallChcekout} />
          
          {/* 错误显示页面 */}
          <AppRoute path="/error/404" component={error404} />
          <AppRoute path="/error/500" component={error500} />
          {/* 默认404 */}
          <AppRoute path="*" component={error404} />
        </Switch>
      </Router>
    );
  }
}
